<ng-template #TermsAndConditions>
    <br/>
    <!-- prettier-ignore -->
    <wuc-link type="secondary" [url]="downloadUrl + 'algemeen.pdf'" iconLeft="download" target="_blank">Algemene
        voorwaarden
    </wuc-link>
</ng-template>

<wuc-rack *ngIf="purchasedProduct" columnsDesktop="1" columnsTablet="1" columnsMobile="1" gridGap="medium">
    <wuc-display-field class="insurance-terms-and-conditions__field">
        <label>Polis / klantnummer</label>
        {{ relation.relation_id }}
    </wuc-display-field>

    <wuc-display-field class="insurance-terms-and-conditions__field">
        <label>Verzekeringsoverzicht</label>
        <wuc-link type="secondary" (clicked)="getPolicy()" iconLeft="download">Download Verzekeringsoverzicht</wuc-link>
    </wuc-display-field>

    <wuc-display-field
        *ngIf="
            [
                validityStatusCodeEnum.Active,
                validityStatusCodeEnum.Future,
                validityStatusCodeEnum.ActiveEnded,
                validityStatusCodeEnum.ActiveChange,
                validityStatusCodeEnum.Disbarred,
                validityStatusCodeEnum.Transfer
            ].includes(purchasedProduct?.product.validityStatusCode)
        "
        class="insurance-terms-and-conditions__field"
    >
        <label>Voorwaarden</label>
        <ng-container
            *ngIf="
                ![productIdEnum.Home, productIdEnum.Moped, productIdEnum.Accidents].includes(purchasedProduct.productId)
            "
        >
            <!-- prettier-ignore -->
            <wuc-link
                type="secondary"
                [url]="downloadUrl + purchasedProduct?.product?.productDescription + '.pdf'"
                iconLeft="download"
                target="_blank"
            >Voorwaarden {{ purchasedProduct?.product?.productDescription }}
            </wuc-link>
            <ng-container *ngTemplateOutlet="TermsAndConditions"></ng-container>
        </ng-container>
        <ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Home">
            <!-- prettier-ignore -->
            <wuc-link
                type="secondary"
                [url]="downloadUrl + 'woonverzekering.pdf'" iconLeft="download"
                target="_blank">Download voorwaarden {{ purchasedProduct?.product?.productDescription }}
            </wuc-link>
            <ng-container *ngTemplateOutlet="TermsAndConditions"></ng-container>
        </ng-container>
        <ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Accidents">
            <!-- prettier-ignore -->
            <wuc-link
                [isFullWidth]="true"
                type="secondary"
                [url]="downloadUrl + 'ongevallenverzekering.pdf'"
                iconLeft="download"
                target="_blank"
            >Download voorwaarden {{ purchasedProduct?.product?.productDescription }}
            </wuc-link>
            <ng-container *ngTemplateOutlet="TermsAndConditions"></ng-container>
        </ng-container>
        <ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Moped">
            <!-- prettier-ignore -->
            <wuc-link
                type="secondary"
                [url]="downloadUrl + 'brommerverzekering.pdf'"
                iconLeft="download"
                target="_blank"
            >Download voorwaarden Brommerverzekering
            </wuc-link>
            <ng-container *ngTemplateOutlet="TermsAndConditions"></ng-container>
        </ng-container>
    </wuc-display-field>
</wuc-rack>
